import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.REPORTING}/`;

export const GetReportHistoryAPI = ({ onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}history`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetReportConfigurationAPI = ({ id, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}configuration?id=${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetAvailableReportsAPI = ({ orgId, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}available-reports/${orgId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const SaveReportConfigurationAPI = ({ payload, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}configuration`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const DeleteReportConfigurationAPI = ({ id, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}configuration/${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const UpdateReportConfigurationAPI = ({ id, payload, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}configuration/${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.PUT,
    payload,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const DownloadReportAPI = async ({
  executionId,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}download/${executionId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    responseType: 'blob',
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
